// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__26OA-","text":"styles_text__3E13Z","date":"styles_date__1E90O"};